import { createAPI } from '@common'
// import { createAPI } from '@common/createApis'

export default {
  // 新建任务
  addTasks: config => createAPI('customEncryptApiName-1/0w20ubtlt', 'post', config, {
    e5namespace: 'TaskAssign'
  }),
  // 获取任务
  getTasks: config => createAPI('customEncryptApiName-1/0w20ubtlt0bttjho', 'get', config)
}
